import React from 'react';
import ActivateObject from '../../../../common/poppers/ActivateObject';
import DeleteObject from '../../../../common/poppers/DeleteObject';
import NewBankAccountNumber from '../../../bankaccountnumber/NewBankAccountNumber';
import ModifyRestrainPartner from './ModifyRestrainPartner';
import RestrainPartnerRow from './RestrainPartnerRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

export const restrainPartnerActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Letiltás partner módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyRestrainPartner {...props} close={close} />
    },
    {
        dataDialog: "new-bankaccount-dialog",
        title: "Bankszámlaszám hozzáadása",
        dialogTitle: "Bankszámlaszám hozzáadása",
        icon: <AddIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <NewBankAccountNumber {...props} close={close} />
    },
    {
        dataDialog: "active-dialog",
        title: "Aktiválás",
        dialogTitle: "Letiltás partner aktiválása",
        icon: <CheckCircleOutlineIcon fontSize="small" color="primary" />,
        canShow: (row) => !row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/restrainpartner/activate'} comp={<RestrainPartnerRow {...props} />} />
    },
    {
        dataDialog: "active-dialog",
        title: "Inaktiválás",
        dialogTitle: "Letiltás partner inaktiválása",
        icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
        canShow: (row) => row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/restrainpartner/activate'} comp={<RestrainPartnerRow {...props} />} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Letiltás partner törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/restrainpartner'} comp={<RestrainPartnerRow {...props} />} />
    }
]